module.exports = __webpack_public_path__ + "img/utility-pill-bg-1.4cb496bf.png";